<template>
  <multiselect 
    placeholder="Select Automation Type"
    :options="types" 
    label="name" 
    track-by="key" 
    :value="selected" 
    @input="handleInput" @remove="handleRemove">
    <template slot="option" slot-scope="props">
      <div>
        <fa :icon="['far', props.option.icon]" class="mr-2 text-gray-500" fixed-width />
        {{ props.option.name }}
      </div>
    </template>
  </multiselect>
</template>

<script>
import { mapState } from 'vuex'
import Multiselect from 'vue-multiselect'

export default {
  name: 'AutomationTypeSelect',

  components: {
    Multiselect
  },

  props: ['value'],

  computed: {
    ...mapState(['automationTypes']),

    types () {
      let types = []
      for (let key in this.automationTypes) {
        types.push({
          key: key,
          ...this.automationTypes[key]
        })
      }
      return types
    },

    selected () {
      return this.types.find(type => type.key === this.value)
    }
  },

  methods: {
    handleInput (value) {
      this.$emit('input', value.key)
    },

    handleRemove () {
      this.$emit('input', null)
    }
  }
}
</script>